import { FC } from 'react';
import {
  LABEL_FLAG,
  FAQ_TITLE,
} from '@doda/common/src/constants/seo/jobTrendConstants';
import classNames from 'classnames';
import style from './index.module.scss';
import { FaqBlock } from './FaqBlock';

/**
 * FAQコンポーネントのProps
 */
interface Props {
  targetName: string;
  requirementsShowFlg: boolean;
  incomeShowFlg: boolean;
  workplaceEnvironmentShowFlg: boolean;
  holidayAndWayOfWorkingShowFlg: boolean;
  employmentStatusShowFlg: boolean;
  rankingList;
}

/**
 * FAQコンポーネント
 * @param {string} targetName ページの一軸名
 */
export const FaqArea: FC<Props> = ({
  targetName,
  requirementsShowFlg,
  incomeShowFlg,
  workplaceEnvironmentShowFlg,
  holidayAndWayOfWorkingShowFlg,
  employmentStatusShowFlg,
  rankingList,
}) => {
  return (
    <section className={style.FaqArea}>
      <h2 className={classNames(style.FaqArea__title, style['title--sizeL'])}>
        {FAQ_TITLE}
      </h2>
      {requirementsShowFlg && (
        <FaqBlock
          targetName={targetName}
          rankingList={rankingList.requirements}
          categoryFlg={LABEL_FLAG.REQUIREMENT}
        />
      )}
      {incomeShowFlg && (
        <FaqBlock
          targetName={targetName}
          rankingList={rankingList.income}
          categoryFlg={LABEL_FLAG.INCOME}
        />
      )}
      {workplaceEnvironmentShowFlg && (
        <FaqBlock
          targetName={targetName}
          rankingList={rankingList.workplaceEnvironment}
          categoryFlg={LABEL_FLAG.WORKPLACE_ENVIRONMENT}
        />
      )}
      {holidayAndWayOfWorkingShowFlg && (
        <FaqBlock
          targetName={targetName}
          rankingList={rankingList.holidayAndWayOfWorking}
          categoryFlg={LABEL_FLAG.HOLIDAY_AND_WAY_OF_WORKING}
        />
      )}
      {employmentStatusShowFlg && (
        <FaqBlock
          targetName={targetName}
          rankingList={rankingList.employmentStatus}
          categoryFlg={LABEL_FLAG.EMPLOYMMENT_STATUS}
        />
      )}
    </section>
  );
};
